import React from "react";
import klashraLogo from "../images/klashra_logo.png"
import { useNavigate } from 'react-router-dom';
const Header = () => {
const navigate = useNavigate();

  const handleNavigation = () => {
    navigate('/check-eligibility');
  };
  return (
    <header className="bg-white ">
    <div className="flex items-center justify-between px-4 py-4 sm:px-6 sm:py-4 md:px-8">
      {/* Left section */}
      <div className="flex items-center space-x-2">
        <h1 className="hidden sm:block text-sm font-medium text-black whitespace-nowrap">
          Family visa calculator by
        </h1>
        <img
          src={klashraLogo}
          alt="KLASHRA Logo"
          className="h-5"
        />
      </div>
  
      {/* Right section */}
      <div className="flex items-center space-x-4">
        {/* <a
          href="https://example.com"
          className="text-sm text-teal-600 hover:underline"
        >
          Sign In
        </a> */}
        <button 
        onClick={handleNavigation}
        className="px-4 py-2 text-sm font-medium text-white bg-[#4EA39D] rounded-[40px] hover:bg-teal-600">
          Book a Demo
        </button>
      </div>
    </div>
  
   
  </header>
  
  );
};

export default Header;
